export const DEALS_FMF_VALUE = 'fmf';

export const DEALS_FILTER_OPTIONS = [
	{ value: 'all', label: 'All Deals' },
	{ value: DEALS_FMF_VALUE, label: 'First Month Free' },
	{ value: 'additional', label: 'Additional Deals' },
];
